import React from "react";
import { useSelector } from "react-redux";
import { selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { IWordQuiz } from "../../../models/interactions/WordQuiz";
import { useTrainingLocalization } from "../../trainingLocalization/TrainingLocalizationHooks";
import PiInteractionTitlePreview from "../components/PiInteractionTitlePreview";
import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import WordQuizBody from "./WordQuizBody";

export default function WordQuizPreview() {
  const quiz = useSelector(selectSelectedElement) as IWordQuiz;
  const { getValue, changeValue } = useTrainingLocalization();

  const title = (
    <PiInteractionTitlePreview
      value={getValue(quiz.title)}
      onChange={(e) => changeValue(quiz.title, e)}
      placeholder="Quiz Title"
      showStarIcons={false}
      key={quiz.id}
    />
  );

  const body = <WordQuizBody />;

  return <PiPopupWindowPreview title={title} body={body} />;
}
